import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

import pl from 'vuetify/src/locale/pl';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#1d009c',
        secondary: '#4caf50',
        tertiary: '#495057',
        accent: '#1d009c',
        error: '#CC2500',
        info: '#00d3ee',
        success: '#86E286',
        warning: '#ffa21a'
      }
    }
  },
  iconfont: 'mdi',
  lang: {
    locales: { pl },
    current: 'pl'
  }
};
export default new (Vuetify as any)(opts);
